var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GRID_LOADED_CLASS = 'loaded';


class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        console.log("event.target: ", event.target);
        const tableRow = event.target.closest('tr')
        event.preventDefault();
        console.log("REMOVE BUTTON CLICKED")
        // const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        // cartItems.updateQuantity(this.dataset.index, 0);

        let lineNumber = 0
        let productId = 0;
        console.log("this.closest('.cart-item'): ", this.closest('.cart-item'))
        console.log("this.closest('.shop-list__item'): ", this.closest('.shop-list__item'))
        if (this.closest('.cart-item') || this.closest('.shop-list__item')) {
          if (this.closest('.cart-item')) {
            lineNumber = Number(this.closest('.cart-item').getAttribute('id').split('-')[1])
            productId = this.closest('.cart-item').getAttribute('data-id')
          }
          if (this.closest('.shop-list__item')) {
            lineNumber = Number(this.closest('.shop-list__item').getAttribute('data-line-id').split('-')[1])
            productId = this.closest('.shop-list__item').getAttribute('data-id')
          }
          console.log("lineNumber: ", lineNumber)
          const body = JSON.stringify({
            // line: lineNumber,
            id: productId,
            quantity: 0,
            sections: [document.getElementById('main-cart-items')?.dataset?.id],
            sections_url: window.location.pathname
          });
          
          console.log("remove body: ", body)

          fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state)
            $.refreshCart(parsedState,false)
            console.log("%cCartRemoveButton parsedState: ", "background-color: orange; color: black;", parsedState)
            if (Object.keys(parsedState.sections).length > 0) {
              const elementToReplace = document.getElementById('main-cart-items')
              const htmlToParse = Object.entries(parsedState.sections)[0]?.[1]
              console.log("htmlToParse: ", htmlToParse)
              elementToReplace.innerHTML = new DOMParser().parseFromString(htmlToParse, 'text/html').querySelector('#main-cart-items').innerHTML
              //perorder message
              updatePreorderBanner();
              //preorder message end
            }

            let dynLineItem;
            // const dynLineItem = document.querySelector(`[data-line-id="CartItem-${lineNumber}"]`)
            if (this.closest('.cart-item')) {
              dynLineItem = document.querySelector(`.shop-list__item[data-id="${productId}"]`)
            } else {
              dynLineItem = this.closest('.shop-list__item')
            }
            console.log("dynLineItem: ", dynLineItem)
            dynLineItem.remove()


          let deliveryPrice = 0.00
          if (Object.keys(parsedState.sections).length > 0) {
            const summaryTotal = document.querySelector('.summary-total')
            const cartItemsTotal = document.querySelector('.cart-subtotal__label__value')
            summaryTotal.innerHTML = `£${Number(parsedState.total_price) / 100}`
            cartItemsTotal.innerHTML = `£${Number(parsedState.total_price) / 100}`
            console.log("%csummaryTotal", "background-color: red;", summaryTotal)
            console.log("%ccartItemsTotal", "background-color: red;", cartItemsTotal)


            const cartItemsTotalAndDelivery = document.querySelector('.cart-subtotal__and__delivery')
            console.log("parsedState.items_subtotal_price", parsedState.items_subtotal_price)
            if (parsedState.items_subtotal_price < 5500) {
              deliveryPrice = 399
            } else {
              deliveryPrice = 0.00
            }
            const deliveryPriceElement = document.querySelector(".summary-delivery")
            
            if (deliveryPrice > 0) {
              deliveryPriceElement.innerHTML = `£${Number(deliveryPrice) / 100}`
            } else {
              deliveryPriceElement.innerHTML = `£0.00`
            }
  
            console.log("deliveryPrice", deliveryPrice)
            cartItemsTotalAndDelivery.innerHTML = `£${(Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100}`
            const clearpayPrice  = document.querySelector("afterpay-placement")
            if (clearpayPrice) {
              console.log("clearpayPrice running", clearpayPrice)
              clearpayPrice.setAttribute("data-amount", (Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100)
            }
            console.log("clearpayPrice", clearpayPrice)
          }


            const deliveryValue = document.querySelector('.dyncart-delivery-value')
            if (parsedState.items_subtotal_price === 0) {
              deliveryValue.innerHTML = `£0.00`
            } else if (deliveryPrice > 0 || parsedState.items_subtotal_price < 5500) {
              deliveryValue.innerHTML = `£${Number(399) / 100}`
            } else {
              deliveryValue.innerHTML = `£0.00`
            }

            const totalValue = document.querySelector('.dyncart-total')
            
            totalValue.innerHTML = `£${((Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100).toFixed(2)}`
            console.log("totalValue (in cart remove button): ", totalValue)

            let remainPrice = 5500 - parsedState.items_subtotal_price
            const bannerText = document.querySelector('.banner-text')
            if (remainPrice <= 0) {
              bannerText.innerHTML = `YOU HAVE QUALIFIED FOR FREE DELIVERY`
            } else {
              bannerText.innerHTML = `£${(Number(remainPrice) / 100).toFixed(2)} AWAY FROM FREE DELIVERY`
            }
            
            const itemCountCart = document.querySelector('.item-count-cart')
            itemCountCart.innerHTML = `${parsedState.item_count}`

            const totalIcon = document.querySelector('.total-icon')
            if (parsedState.items_subtotal_price !== 0) {
              totalIcon.innerHTML = `£${(Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100}`
            } else {
              totalIcon.innerHTML = `£0.00`
            }

          })
        } else {
          lineNumber = this.closest('.shop-list__item').getAttribute('data-line-id').split('-')[1]
          console.log("lineNumber: ", lineNumber)
          const mobileLineItem = document.querySelector(`.shop-list__item[data-line-id="CartItem-${lineNumber}"]`)
          mobileLineItem.remove()
        }



        // const body = JSON.stringify({
        //   line: lineNumber,
        //   quantity: 0,
        //   // sections: [document.getElementById('main-cart-items').dataset.id],
        //   sections_url: window.location.pathname
        // });

        // fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        // .then((response) => response.text())
        // .then((state) => {
        //   const parsedState = JSON.parse(state)
        //   console.log("%cCartRemoveButton parsedState: ", "background-color: orange; color: black;", parsedState)
        //   const elementToReplace = document.getElementById('main-cart-items')
        //   const htmlToParse = Object.entries(parsedState.sections)[0][1]
        //   console.log("htmlToParse: ", htmlToParse)
        //   elementToReplace.innerHTML = new DOMParser().parseFromString(htmlToParse, 'text/html').querySelector('#main-cart-items').innerHTML

        //   const summaryTotal = document.querySelector('.summary-total')
        //   summaryTotal.innerHTML = `£${Number(parsedState.total_price) / 100}`
        //   console.log("%csummaryTotal", "background-color: red;", summaryTotal)
        // })
      });
    }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
      super();
  
      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
      console.log('this.lineItemStatusElement: ', this.lineItemStatusElement);
      this.shopListItems = document.querySelectorAll('.shop-list__item')

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
      console.log("this.currentItemCount constructor: ", this.currentItemCount)
      this.debouncedOnChange = debounce((event) => {
        console.log("debouncedOnChange: ", event)
        this.onChange(event);
      }, 300);
  
      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.shopListItems.forEach((item) => {
        console.log("shoplistitem: ", item)
        item.addEventListener('change', (event) => {
          console.log("shoplistitems event: ", event)
          console.log("this: ", this)
          this.debouncedOnChange.bind(this);
        });
      })
    }
  
    onChange(event) {
      console.log("onChange: ", event)
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event);
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items')?.dataset?.id,
          selector: '.js-contents',
        },
        // {
        //   id: 'cart-icon-bubble',
        //   section: 'cart-icon-bubble',
        //   selector: '.shopify-section'
        // },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        }
        // {
        //   id: 'main-cart-footer',
        //   section: document.getElementById('main-cart-footer').dataset.id,
        //   selector: '.js-contents',
        // }
      ];
    }
  
    updateQuantity(line, quantity, name, event) {
      console.group("updateQuantity");
      console.log("updateQuantity: ", line, quantity, name)
      // const clearpayPrice  = document.getElementsByTagName("afterpay-placement")
      // console.log("clearpayPrice: ", clearpayPrice)
      this.enableLoading(line);
      let productId = ""
      // if (this.closest('.cart-item') || this.closest('.shop-list__item')) {
        if (event.target.closest('.cart-item')) {
          console.log('productId (before quantity if statement', event.target, event.target.closest('.cart-item'))
          // lineNumber = Number(this.closest('.cart-item').getAttribute('id').split('-')[1])
          productId = event.target.closest('.cart-item').getAttribute('data-id')
        }
        if (event.target.closest('.shop-list__item')) {
          // lineNumber = Number(this.closest('.shop-list__item').getAttribute('data-line-id').split('-')[1])
          productId = event.target.closest('.shop-list__item').getAttribute('data-id')
        }
      // }
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      console.log("Quantity update prefetch:", body)
      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          console.log("quantityresponse: ", response)
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          console.log("%cparsedState: ", "background-color: orange; color: black;", parsedState);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          // const cartDrawerWrapper = document.querySelector('.shop-list');
          const cartFooter = document.getElementById('main-cart-footer');
          
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          
          this.getSectionsToRender().forEach((section => {
            console.log("%csection: ", "color: orange;", section)
            // const elementToReplace = document.getElementById(section?.id).querySelector(section?.selector) || document.getElementById(section?.id);
            const elementToReplace = document.getElementById(section?.id);
            console.log("elementToReplace: ", elementToReplace)
            if (elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState?.sections[section?.section], section?.selector);
            }
            console.log(parsedState.sections[section.section])
            // console.log(this.getSectionInnerHTML(parsedState.sections[section.section], section.selector));
            // console.log(elementToReplace.innerHTML);
            console.log("=================================================================")
          }));
          
          this.updateLiveRegions(line, parsedState?.item_count);
          // const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          const lineItem =  document.getElementById(`CartItem-${line}`);
          const lineItemDynamic = document.getElementById(`CartDrawer-Item-${line}`)
          console.log("%clineItem: ", "color: orange;", lineItem)
          console.log("%clineItemDynamic: ", "color: orange;", lineItemDynamic)
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            console.log("lineitem if Running ....")
            console.log("cartDrawerWrapper: ", cartDrawerWrapper)
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            console.log("parsedstate If Running ....")
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            console.log("Else If Running ....")
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
          }
          
          const summaryTotal = document.querySelector('.summary-total')
          if (summaryTotal) {
            summaryTotal.innerHTML = `£${Number(parsedState.items_subtotal_price) / 100}`
            console.log("%csummaryTotal", "background-color: red;", summaryTotal)
          }
          
          
          // const summarySubtotal = document.getElementById('#summary-subtotal')
          // summarySubtotal.innerHTML = `£${Number(parsedState.total_price) / 100}`
          // console.log("%csummarySubtotal", "background-color: red;", summarySubtotal)
          
          const cartItemsTotal = document.querySelector('.cart-subtotal__label__value')
          if (cartItemsTotal) {
            summaryTotal.innerHTML = `£${Number(parsedState.items_subtotal_price) / 100}`
            cartItemsTotal.innerHTML = `£${Number(parsedState.items_subtotal_price) / 100}`
            console.log("%csummaryTotal", "background-color: red;", summaryTotal)
            console.log("%ccartItemsTotal", "background-color: red;", cartItemsTotal)
          }
          
          let deliveryPrice = 0.00
          const cartItemsTotalAndDelivery = document.querySelector('.cart-subtotal__and__delivery')
          if (parsedState.items_subtotal_price < 5500) {
            deliveryPrice = 399
          } else {
            deliveryPrice = 0.00
          }
          if (cartItemsTotalAndDelivery) {
            console.log("parsedState.items_subtotal_price", parsedState.items_subtotal_price)
            console.log("deliveryPrice", deliveryPrice)
            cartItemsTotalAndDelivery.innerHTML = `£${(Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100}`
            const clearpayPrice  = document.querySelector("afterpay-placement")
            if (clearpayPrice) {
              console.log("clearpayPrice running", clearpayPrice)
              clearpayPrice.setAttribute("data-amount", (Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100)
            }
            console.log("clearpayPrice", clearpayPrice)
          }
          const deliveryPriceElement = document?.querySelector(".summary-delivery")
          if (deliveryPriceElement) {
            if (deliveryPrice > 0) {
              deliveryPriceElement.innerHTML = `£${Number(deliveryPrice) / 100}`
            } else {
              deliveryPriceElement.innerHTML = `£0.00`
            }
          }
          console.log("updatequantity TEST")
          
          const deliveryValue = document.querySelector('.dyncart-delivery-value')
          console.log("deliveryValue", deliveryValue)
          console.log("deliveryPrice before set", deliveryPrice)
          if (deliveryPrice > 0) {
            deliveryValue.innerHTML = `£${Number(deliveryPrice) / 100}`
          } else {
            deliveryValue.innerHTML = `£0.00`
          }
          console.log("line: (2)", line)

          const totalValue = document.querySelector('.dyncart-total')

          totalValue.innerHTML = `£${(Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100}`

          let remainPrice = 5500 - parsedState.items_subtotal_price
          const bannerText = document.querySelector('.banner-text')
          if (remainPrice <= 0) {
            bannerText.innerHTML = `YOU HAVE QUALIFIED FOR FREE DELIVERY`
          } else {
            bannerText.innerHTML = `£${Number(remainPrice) / 100} AWAY FROM FREE DELIVERY`
          }


          const itemCountCart = document.querySelector('.item-count-cart')
          itemCountCart.innerHTML = `${parsedState.item_count}`

          const totalIcon = document.querySelector('.total-icon')
          if (parsedState.items_subtotal_price !== 0) {
            console.log("totalIcon if statement")
            totalIcon.innerHTML = `£${(Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100}`
          } else {
            totalIcon.innerHTML = `£0.00`
          }

          // const quantityValues = document.querySelectorAll('.quantity__input')
          const quantityValues = document.querySelectorAll(`.quantity__input#Quantity-${line}`)
          console.log("quantityValues", quantityValues)
          console.log("parsedState (before quantity): ", parsedState)
          console.log("productId (before quantity): ", productId)
          const dynShopList = document.getElementById('shop-list')
          const matchingDynLineItem = dynShopList.querySelector(`[data-id="${productId}"]`)
          console.log("matchingDynLineItem: ", matchingDynLineItem)
          // const productQuantityChanged = parsedState.items[line].quantity
          quantityValues.forEach((quantityValue) => {
            console.log("quantityValue: foreach ", quantityValue, Number(productId))
            for (let i = 0; i < parsedState.items.length; i++) {
              console.log("parsedState.items[i].id: ", parsedState.items[i].id, productId)
              if (parsedState.items[i].id === Number(productId)) {
                console.log("if statement run (first)", quantityValue, parsedState.items[i].id, Number(productId))
                quantityValue.setAttribute('value', parsedState.items[i].quantity)
              }
              if (parsedState.items[i].id === Number(matchingDynLineItem.dataset.id)) {
                console.log("if statement run (second)", quantityValue, parsedState.items[i].id, Number(productId))
                quantityValue.setAttribute('value', parsedState.items[i].quantity)
              }
            }
          })

          this.disableLoading();
        }).catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          // const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          // console.log("errors: ", errors)
          // errors.textContent = window.cartStrings.error;
          this.disableLoading();
        });
        console.groupEnd();
    }
  
    updateLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        console.log("%cLine Item Error", "background-color: red; color: white;")
        const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

        const lineItemErrorText = document.querySelector('.cart-item__error-text')
        // lineItemErrorText.innerHTML = window.cartStrings.quantityError.replace('[quantity]', quantityElement.value);
      }
      if (itemCount) {
        this.currentItemCount = itemCount;
      }
      // console.log("this.currentItemCount: ", this.currentItemCount)
      if (this.lineItemStatusElement) {
        this.lineItemStatusElement.setAttribute('aria-hidden', true);
      }
      
      const cartStatus = document.getElementById('cart-live-region-text');
      const dynCartStatus = document.getElementById('CartDrawer-LiveRegionText');
      if (cartStatus) {
        cartStatus.setAttribute('aria-hidden', false);
      }
      // console.log("cartStatus: ", cartStatus)
      
      setTimeout(() => {
        cartStatus?.setAttribute('aria-hidden', true);
        // console.log("cartStatus: ", cartStatus)
      }, 1000);
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  
    enableLoading(line) {
      console.group("enableLoading")

      // const mainCartItems = document.getElementById('shop-list');

      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('shop-list');

      console.log("mainCartItems", mainCartItems);
      mainCartItems.classList.add('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
      // console.log("cartItemElements: ", cartItemElements)
  
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
      console.log("document.activeElement: ", document.activeElement)
      document.activeElement.blur();
      this.lineItemStatusElement?.setAttribute('aria-hidden', false);
      console.groupEnd();
    }
  
    disableLoading() {
      console.group('disableLoading');
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      console.log('mainCartItems: ', mainCartItems)
      mainCartItems?.classList?.remove('cart__items--disabled');
      console.groupEnd();
    }
  }

customElements.define('cart-items', CartItems);

class SaveForLater extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        console.log("event.target: ", event.target);
        const tableRow = event.target.closest('.cart-item')
        event.preventDefault();
        console.log("tableRow: ", tableRow)
        const handle = tableRow.getAttribute("data-handle")
        console.log("handle: ", handle)
        console.log("localStorage[LOCAL_STORAGE_WISHLIST_KEY]: ", localStorage[LOCAL_STORAGE_WISHLIST_KEY])


        let wishlistArray = [];
        if (localStorage[LOCAL_STORAGE_WISHLIST_KEY] !== undefined) {
          wishlistArray = localStorage[LOCAL_STORAGE_WISHLIST_KEY].split(',');
        }

        console.log("wishlistArray: ", wishlistArray)
        if (wishlistArray.includes(handle)) {
          console.log("handle already in wishlist")
        } else {
          console.log("handle not in wishlist")
          wishlistArray.push(handle)
          localStorage[LOCAL_STORAGE_WISHLIST_KEY] = wishlistArray.join(',')
          console.log("wishlist after join: ", localStorage[LOCAL_STORAGE_WISHLIST_KEY])
        }

        const lineNumber = this.closest('.cart-item').getAttribute('id').split('-')[1]
        console.log("lineNumber: ", lineNumber)

        const body = JSON.stringify({
          line: lineNumber,
          quantity: 0,
          sections: [document.getElementById('main-cart-items').dataset.id],
          sections_url: window.location.pathname
        });

        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state)
            console.log("%cSave for Later parsedState: ", "background-color: orange; color: black;", parsedState)
            const elementToReplace = document.getElementById('main-cart-items')
            const htmlToParse = Object.entries(parsedState.sections)[0][1]
            console.log("htmlToParse: ", htmlToParse)
            elementToReplace.innerHTML = new DOMParser().parseFromString(htmlToParse, 'text/html').querySelector('#main-cart-items').innerHTML

            const summaryTotal = document.querySelector('.summary-total')
            if (summaryTotal) {
              summaryTotal.innerHTML = `£${Number(parsedState.items_subtotal_price) / 100}`
              console.log("%csummaryTotal", "background-color: red;", summaryTotal)
            }
            
            
            // const summarySubtotal = document.getElementById('#summary-subtotal')
            // summarySubtotal.innerHTML = `£${Number(parsedState.total_price) / 100}`
            // console.log("%csummarySubtotal", "background-color: red;", summarySubtotal)
            
            const cartItemsTotal = document.querySelector('.cart-subtotal__label__value')
            if (cartItemsTotal) {
              summaryTotal.innerHTML = `£${Number(parsedState.items_subtotal_price) / 100}`
              cartItemsTotal.innerHTML = `£${Number(parsedState.items_subtotal_price) / 100}`
              console.log("%csummaryTotal", "background-color: red;", summaryTotal)
              console.log("%ccartItemsTotal", "background-color: red;", cartItemsTotal)
            }
            
            let deliveryPrice = 0.00
            const cartItemsTotalAndDelivery = document.querySelector('.cart-subtotal__and__delivery')
            if (parsedState.items_subtotal_price < 5500) {
              deliveryPrice = 399
            } else {
              deliveryPrice = 0.00
            }
            if (cartItemsTotalAndDelivery) {
              console.log("parsedState.items_subtotal_price", parsedState.items_subtotal_price)
              console.log("deliveryPrice", deliveryPrice)
              cartItemsTotalAndDelivery.innerHTML = `£${(Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100}`
              const clearpayPrice  = document.querySelector("afterpay-placement")
              if (clearpayPrice) {
                console.log("clearpayPrice running", clearpayPrice)
                clearpayPrice.setAttribute("data-amount", (Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100)
              }
              console.log("clearpayPrice", clearpayPrice)
            }
            const deliveryPriceElement = document.querySelector(".summary-delivery")
            if (deliveryPriceElement) {
              if (deliveryPrice > 0) {
                deliveryPriceElement.innerHTML = `£${Number(deliveryPrice) / 100}`
              } else {
                deliveryPriceElement.innerHTML = `£0.00`
              }
            }
            
            
            const deliveryValue = document.querySelector('.dyncart-delivery-value')
            console.log("deliveryValue", deliveryValue)
            console.log("deliveryPrice before set", deliveryPrice)
            if (deliveryPrice > 0) {
              deliveryValue.innerHTML = `£${Number(deliveryPrice) / 100}`
            } else {
              deliveryValue.innerHTML = `£0.00`
            }
            // console.log("line: (2)", line)
  
            const totalValue = document.querySelector('.dyncart-total')
  
            totalValue.innerHTML = `£${(Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100}`
  
            let remainPrice = 5500 - parsedState.items_subtotal_price
            const bannerText = document.querySelector('.banner-text')
            if (remainPrice <= 0) {
              bannerText.innerHTML = `YOU HAVE QUALIFIED FOR FREE DELIVERY`
            } else {
              bannerText.innerHTML = `£${Number(remainPrice) / 100} AWAY FROM FREE DELIVERY`
            }
  
            const itemCountCart = document.querySelector('.item-count-cart')
            itemCountCart.innerHTML = `${parsedState.item_count}`

            const totalIcon = document.querySelector('.total-icon')
            if (parsedState.items_subtotal_price !== 0) {
              totalIcon.innerHTML = `£${(Number(parsedState.items_subtotal_price) + Number(deliveryPrice)) / 100}`
            } else {
              totalIcon.innerHTML = `£0.00`
            }


            let productId = 0;

            let dynLineItem;
            // const dynLineItem = document.querySelector(`[data-line-id="CartItem-${lineNumber}"]`)
            if (this.closest('.cart-item')) {
              productId = this.closest('.cart-item').getAttribute('data-id')
              dynLineItem = document.querySelector(`.shop-list__item[data-id="${productId}"]`)
            } else {
              dynLineItem = this.closest('.shop-list__item')
            }
            console.log("dynLineItem: ", dynLineItem)
            dynLineItem.remove()
          })
      });
    }
}

customElements.define('save-for-later', SaveForLater);

class CartSummary extends HTMLElement {
    constructor() {
      super();
  
      this.quantityInput = document.querySelectorAll('.quantity__button');
      // console.log("%cquantityInput: ", "color: purple;", this.quantityInput);

      this.quantityInput.forEach((input) => {
        input.addEventListener('summary-update', this.onUpdate.bind(this));
      })
      let svgCards = this.querySelectorAll('.payment_type_svg_tag')
      svgCards.forEach((svgCard) => {
        svgCard.removeAttribute('width')
        svgCard.removeAttribute('height')
      })
    }

    onUpdate() {
      // console.log("%conUpdate", "background-color: lime;")
      const summaryTotal = document.querySelector('.cart-subtotal__label__value');
      const lineItemPrices = document.querySelectorAll('.cart-item__price');
      const summaryTotalValues = [...lineItemPrices].map((price) => Number(price.innerText));
      console.log("summaryTotalValues: ", summaryTotalValues)
      // summaryTotalValues = summaryTotalValues.reduce((a, b) => a + b, 0);
      // console.log("summaryTotalValues: ", summaryTotalValues)
        
      // summaryTotal.textContent = summaryTotalValues[0]
      
    }
}

customElements.define('cart-summary', CartSummary);

class EditProduct extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        event.preventDefault();
        localStorage.setItem('shopify-edit-state', JSON.stringify([this.closest('.cart-item').getAttribute('id').split('-')[1], this.closest('.cart-item').getAttribute('data-id'), this.closest('.cart-item').getAttribute('data-handle'), this.closest('.cart-item').getAttribute('data-key')]));
        window.location.href = `/products/${this.closest('.cart-item').getAttribute('data-handle')}?variant=${this.closest('.cart-item').getAttribute('data-id')}`;
      });
    }
}

customElements.define('edit-product', EditProduct);

//preorder message 
function updatePreorderBanner() {
  const preorderBanner = document.querySelector('.js-Preorder_Banner');
  const cartItems = document.querySelectorAll('.cart-item');

  let hasPreorder = false;

  cartItems.forEach(item => {
    if (item.dataset.preorder === 'true') {
      hasPreorder = true;
    }
  });

  if (preorderBanner) {
    preorderBanner.style.display = hasPreorder ? 'block' : 'none';
  }
}

// Call this whenever cart is updated
document.addEventListener('DOMContentLoaded', updatePreorderBanner);

// Optional: trigger after custom cart update logic
document.addEventListener('cart:updated', updatePreorderBanner);

// OR call directly after replacing innerHTML (if no event is triggered)

//preorder message end